import { AuthContextProps } from "../components/auth-context";
import { getData } from "./core";

export default class NewRequestResendCodeApi {
  static authorizedUri = "a/accounts/newRequestResendCode";
  context?: AuthContextProps;
  constructor(context?: AuthContextProps) {
    this.context = context;
  }

  get(id: string) {
    return getData({
      uri: NewRequestResendCodeApi.authorizedUri,
      id,
      context: this.context,
    });
  }
}
